<div class="title-components">
  <h1>TAREAS PENDIENTES</h1>
</div>

<div class="Content-Tasks">
  <ng-container *ngIf="LoadPage; else LoadingState">
    <ng-container *ngIf="HasPendingTasks(); else EmptyState">
      <ng-container *ngFor="let Library of AllLibraries">
        <ng-container *ngFor="let Library_Task of Library.Library">
          <div class="Card-Task">
            <div class="Content-Card">
              <div class="Card-Notification">
                <div class="notifications button-square">
                  <i class="far fa-bell"></i>
                  <span class="number-circle">{{ Library_Task.Task }}</span>
                </div>
              </div>
              <div class="Body-Card">
                <div class="Title-Card">
                  <h2>{{ Library_Task.Name_library }}</h2>
                </div>
                <div class="Subtitle-Card">
                  {{ GetGreeting() }}, {{ NameUser() }}, tiene
                  {{ Library_Task.Task }} tareas asignadas en
                  {{ Library_Task.Name_library }}.
                </div>
              </div>
            </div>
            <div class="Btn-See-Task">
              <button
                [routerLink]="GetRoutePath(Library_Task.RouteLink)"
                [queryParams]="GetRouteQueryParams(Library_Task.RouteLink)"
                class="Btn-Task btn-icon-text-left"
              >
                <span class="text"> Ver tareas </span
                ><i class="fa-solid fa-list-check"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-template #LoadingState></ng-template>

  <ng-template #EmptyState>
    <div class="Empty-Tasks-State">
      <div class="Empty-Tasks-State__Icon">
        <i class="fa-regular fa-bell-slash"></i>
      </div>
      <div class="Empty-Tasks-State__Content">
        <h2>No tienes tareas pendientes por el momento</h2>
        <p>Cuando existan tareas asignadas en alguna librería, aparecerán aquí.</p>
      </div>
    </div>
  </ng-template>
</div>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="LoaderTask">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
